export default __webpack_public_path__ + "static/media/pdf.4fa7d136.svg";